import { Component } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import * as auth from '../store/authentication/AuthSlice';
import { LayoutSplashScreen } from '../shared/layout';

interface LogoutProps {
    hasAuthToken: boolean;
    logout: () => void;
}

class Logout extends Component<LogoutProps> {
    componentDidMount() {
        this.props.logout();
    }

    render() {
        const { hasAuthToken } = this.props;
        return hasAuthToken ? <LayoutSplashScreen /> : <Navigate to="/" />;
    }
}

const mapState = (state: any) => ({
    hasAuthToken: Boolean(state.auth.authToken),
});

const mapDispatch = {
    logout: auth.actions.logout,
};

export default connect(mapState, mapDispatch)(Logout);
